// @flow
import {
  getErrorStatusAndDetailFromErrorObject,
  toastError,
  toastSuccess,
} from '@presentational/notifications/utils';
import { useUploadDiscountsToSFDCMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { useParams } from 'react-router-dom';
import React from 'react';
import { ButtonWithPopup } from '@presentational/ButtonWithPopup';

export const SPPushDiscountsToSFDCBtn = () => {
  const { orgId, commitId } = useParams();
  const [uploadDataToSFDCFunc] = useUploadDiscountsToSFDCMutation();
  const isDisabled = true;
  const getTooltipText = () => {
    return 'CE2 is deprecated, please use CE1!';
  };

  return (
    <ButtonWithPopup
      circular={true}
      compact={true}
      disabled={isDisabled}
      onClick={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { error } = await uploadDataToSFDCFunc({
          orgId,
          commitId,
        });
        if (error) {
          const { errorDetail } = getErrorStatusAndDetailFromErrorObject(error);
          toastError(error, errorDetail);
        } else {
          toastSuccess('Successfully uploaded the data to SFDC!!');
        }
      }}
      popupContent={getTooltipText()}
      size="mini"
      text="Push Data To SFDC"
    />
  );
};
